SftpServerEditionController.$inject = ['$scope',
                                   '$translate',
                                   '$mdDialog',
                                   '$stateParams',
                                   'UserFactory',
                                   'StrategiesFactory',
                                   'AlertingFactory',
                                   'SftpServersFactory',
                                   'company',
                                   'sftpServer',
                                   'isCreation'];
export function SftpServerEditionController($scope,
                                        $translate,
                                        $mdDialog,
                                        $stateParams,
                                        UserFactory,
                                        StrategiesFactory,
                                        AlertingFactory,
                                        SftpServersFactory,
                                        company,
                                        sftpServer,
                                        isCreation) {

  $scope.submitSftpServer = submitSftpServer;
  $scope.cancel = cancel;
  $scope.reGeneratePublicKey = reGeneratePublicKey;
  $scope.testConnectivity = testConnectivity;

  init();

  function submitSftpServer() {
    $mdDialog.hide($scope.sftpServer);
  };

  function cancel() {
    $mdDialog.cancel();
  };

  function reGeneratePublicKey() {
    SftpServersFactory.createSftpServerKey($stateParams.companyId, sftpServer).then(function(response) {
      $scope.sftpPublicKey = response.data.sftp_public_key;
      $scope.sftpServer.public_key = response.data.public_key;
      $scope.sftpServer.encrypted_private_key = response.data.encrypted_private_key;
    }, AlertingFactory.httpErrorHandler());
  }

  function testConnectivity() {
    SftpServersFactory.testSftpServerConnectivity($stateParams.companyId, $scope.sftpServer).then(function(response) {
      AlertingFactory.success('sftp-servers/connectivity/ok');
    }, function (response) {
      let message = 'sftp-servers/connectivity/' + response.data.error;
      AlertingFactory.error(message);
    });
  }

  function init() {
    $scope.sftpServer = sftpServer;
    $scope.isCreation = isCreation;
    let titleKey = isCreation ? 'sftp-servers/edition/create-title' : 'sftp-servers/edition/edit-title';
    $scope.dialogTitle = $translate.instant(titleKey);
  }

}